import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import FormLauncher from '../../../../cmn/docAutomation/FormLauncher';
import FormDialog from '../../../../../library/form/components/FormDialog';
import SarasTrans from "../../../../../library/notifications/SarasTrans";
import { UiForm } from "../../../../../library/layout/Index";

const ProdMatrixContainer = (props) => {
    const { viewMap, formObject, viewData, ...restProps } = props;

    // console.log("production view map", viewMap);

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }}}
            formStyle={{ width: '900px', height: '650px' }} contentStyle={{ height: '450px' }}
            formTitle={<SarasTrans value='Order Variations' />}
        >
            <div>
                <UiForm formName="header">
                    <FormLauncher viewMap={viewMap} compositionKey="matrixHeader" viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
                <UiForm formName="matrixDetails">
                    <FormLauncher viewMap={viewMap} compositionKey="matrixChart" viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </div>
        </FormDialog>
    )
}

export default withView(ProdMatrixContainer, "prodMatrixGroup", "")